export const priorityArr = [
  { value: "open", label: "Open Tickets", color: "#3B8AFF" },
  { value: "progress", label: "In Progress", color: "#FAC885" },
  { value: "done", label: "Closed", color: "#54C104" },
];
export const issueTypeArr = [
  { value: "general-inquiry", label: "General Inquiry" },
  {
    value: "subscription-issue",
    label: "Subscription Issue",
  },
  { value: "payment-issue", label: "Payment Issue" },
  {
    value: "technical-issue",
    label: "Technical Issue Issue",
  },
  { value: "customer-feedback", label: "Customer Feedback" },
];
